module.exports = __webpack_public_path__ + "4adaaf46668cfdc7f20212f91eb7d272.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 214
 ** module chunks = 1
 **/